import { ElementType, SetStateAction, useState } from 'react';
import { AppBar as MuiAppBar, Toolbar, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { LogoText } from '@my-helpers/common';
import ThemeSwitch from '@/components/layout/ThemeSwitch';
import UserAvatar from '@/components/layout/UserAvatar';
import UserMenu from '@/components/layout/UserMenu';
import { APP_BAR_HEIGHT } from '@/constants/layout';

interface AppBarProps {
	darkMode: boolean
	setDarkMode: (darkMode: boolean) => void
	signOut: () => void
}

const AppBar: ElementType<AppBarProps> = ({ darkMode, setDarkMode, signOut }) => {
	const theme = useTheme();

	// Handler for theme toggle
	const handleThemeToggle = () => {
		setDarkMode(!darkMode);
	};

	const [userMenuAnchorEl, setUserMenuAnchorEl] = useState(null);
	// Handler for user menu
	const handleUserMenuOpen = (event: SetStateAction<any>) => {
		setUserMenuAnchorEl(event.currentTarget);
	};

	const handleUserMenuClose = () => {
		setUserMenuAnchorEl(null);
	};

	return (
		<MuiAppBar 
			position="fixed"
			sx={{ 
				height: APP_BAR_HEIGHT,
				zIndex: (theme) => theme.zIndex.drawer + 1
			}}
		>
			<Toolbar>
				<Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
					<LogoText 
						height={40}
						width="auto"
						fill={theme.palette.primary.contrastText}
						strokeWidth={1.5}
					/>
				</Box>
				<Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-end' }}>
					<ThemeSwitch darkMode={darkMode} handleThemeToggle={handleThemeToggle} />
					<UserAvatar handleUserMenuOpen={handleUserMenuOpen} />
					<UserMenu 
						userMenuAnchorEl={userMenuAnchorEl} 
						handleUserMenuClose={handleUserMenuClose}
						signOut={signOut}
					/>
				</Box>
			</Toolbar>
		</MuiAppBar>
	)
}

export default AppBar;